import React from "react";

import "../Player.css";

import ChooseSongBody from "./ChooseSongBody";

// import Footer from "./Footer";

function Player({ suchbegriff, searchResults}) {




  return (
    <div className="player">
      <div className="player__body">
        {/* <Sidebar /> */}
        <ChooseSongBody suchbegriff={suchbegriff} searchResults={searchResults}/>
      </div>
    
    </div>
  );



}
export default Player;
